
import { Input, Button, Space } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import React from 'react';

const CreateColumn = (config, getApi) => {

    // const [state,setState] = React.useState({
    //     searchText: '',
    //     searchedColumn: '',
    // });

    // const handleSearch = (selectedKeys, confirm, dataIndex) => {
    //     //confirm();
    //     setState({
    //       searchText: selectedKeys[0],
    //       searchedColumn: dataIndex,
    //     });
    //   };
    
    //   const handleReset = clearFilters => {
    //     //clearFilters();
    //     setState({ searchText: '' });
    //   };
    
    // const getColumnSearchProps = dataIndex => ({
    //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    //       <div style={{ padding: 8 }}>
    //         <Input
    //           ref={node => {
    //             //this.searchInput = node;
    //           }}
    //           placeholder={`Search ${dataIndex}`}
    //           value={selectedKeys[0]}
    //           onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
    //           onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
    //           style={{ marginBottom: 8, display: 'block' }}
    //         />
    //         <Space>
    //           <Button
    //             type="primary"
    //             onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
    //             icon={<SearchOutlined />}
    //             size="small"
    //             style={{ width: 90 }}
    //           >
    //             Search
    //           </Button>
    //           <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
    //             Reset
    //           </Button>
    //           <Button
    //             type="link"
    //             size="small"
    //             onClick={() => {
    //               confirm({ closeDropdown: false });
    //               setState({
    //                 searchText: selectedKeys[0],
    //                 searchedColumn: dataIndex,
    //               });
    //             }}
    //           >
    //             Filter
    //           </Button>
    //         </Space>
    //       </div>
    //     ),
    //     filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    //     onFilter: (value, record) =>
    //       record[dataIndex]
    //         ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
    //         : '',
    //     onFilterDropdownVisibleChange: visible => {
    //       if (visible) {
    //         //setTimeout(() => this.searchInput.select(), 100);
    //       }
    //     },
    //     render: text =>
    //       state.searchedColumn === dataIndex ? (
    //         <Highlighter
    //           highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
    //           searchWords={[state.searchText]}
    //           autoEscape
    //           textToHighlight={text ? text.toString() : ''}
    //         />
    //       ) : (
    //         text
    //       ),
    //   });

    

    return config.fields.map((field, index) => {
        let col = {
            key: field.name,
            dataIndex: field.name,
            colSpan: field.colSpan,
            title: field.label,
            width: field.width || 'auto',
            sorter: field.sorter,
            render: field.render,
            // textWrap: 'word-break',
            // ellipsis: true,
            /*
            shouldCellUpdate: (record, prevRecord) => {
                console.log('shouldCellUpdate');
                return 1!=2;
            },*/
            onCell: (record, rowIndex) => ({
                record,
                config: field,
                onClick: async(event) => {
                    //console.log(`cellClick => rowIndex: ${rowIndex}, key: ${record?.key}, name: ${field?.name}`);
                    await getApi().onCellClick(record, field, rowIndex);

                    //if (getApi().isEditable()){
                        //getApi().selectItemEditingEvent(record, field);
                        
                    //}
                },
                //onDoubleClick: event => {console.log('cellEvent');}, // double click row
                //onContextMenu: event => {}, // right button click row
                //onMouseEnter: event => {}, // mouse enter row
                //onMouseLeave: event => {}, // mouse leave row
            }),
           // ...getColumnSearchProps(field.name)
        };
        /* solo cuando una columna es editable */
        return col;
    });
}

export default CreateColumn;



